import React from "react";
import FarmerImg from "../../../images/gbrPN/PNImg1.webp";
import UpdatesBanner from "../../UpdatesBanner/UpdatesBanner";
import PNBenefits from "../Benefits/PNBenefits";
import HomeSubSection from "../HomeSubSection/HomeSubSection";
import PN from "../../../images/GBR Network (PPN Network) - 21-03-2025 N.gif";
import ProductionManagerImg from "../../../images/DTN Network - GBR Tech - 23-04-2024 N.gif";
import { Container } from "@material-ui/core";
import PPNServices from "./PPNServices";
import PPNBenefits from "./PPNBenefits";
import PPNFeatures from "./PPNFeatures";
// Main component for PPN Network
export default function PPN() {
  return (
    <>
      {/* Banner Section - Displays the main theme of the PPN network */}
      <UpdatesBanner
        className="pnbg text-white"
        bannerTitle="Monetize Platform"
        bannerbodycopy1={[
          <span key="1">
            Network for Agrifood MSMEs to Monetize the unutilized capacities
          </span>,
          <br key="2" className="d-lg-block d-none"></br>,
          <span key="3">to maximize the profit</span>,
        ]}
      />

      {/* Overview Section */}
      <div className="mt-5 mb-5">
        <Container>
          <h4 className="container-title text-center mx-md-4 ">Overview</h4>
        </Container>

        {/* HomeSubSection component introduces PPN and its benefits */}
        <HomeSubSection
          fontBold="true"
          className1="aboutBgGrey"
          className="rowReverseAbout align-items-center"
          listItems={<PNBenefits />} // Displays benefits of PPN
          description="Production network is designed to manage investable assets by agribusiness for following benefits"
          src={PN}
          grid={true}
          btn2={true}
        />
      </div>

      {/* Service section */}
      <PPNServices />
      {/* Features section */}

      <PPNFeatures title="Features" />
      {/* Benefits section */}

      <PPNBenefits />

      {/* Beneficiaries Section  */}
      <div className="network-wrapper">
        <h2 className="container-title text-center mt-4">
          BENEFICIARIES OF THE PPN NETWORK
        </h2>

        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="image11"
          description="Brands/Buyers are companies or businesses that purchase processed food products from Agri Contract Manufacturers (ACMs)."
          descriptionTitle="Brands/Buyers"
          src={FarmerImg}
          buttoncont1="Explore"
          href1="/brands-buyers"
        />

        <HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="agri-foodmanufacturer-img"
          description="A Plant QA (Quality Assurance) Officer ensures that all production processes meet quality and safety standards."
          descriptionTitle="Plant QA"
          src={ProductionManagerImg}
          buttoncont1="Explore"
          href1="/plant-qa"
        />

        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="agribusiness-img"
          description="Logistic providers ensure efficient product movement and optimal resource utilization in the agricultural network."
          descriptionTitle="Plant Manager/Supervisor"
          src={ProductionManagerImg}
          buttoncont1="Explore"
          href1="/plant-manager"
        />

        <HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="agri-foodmanufacturer-img"
          description="A Maintenance Engineer is responsible for inspecting, repairing, and maintaining machinery, equipment, and infrastructure in a plant."
          descriptionTitle="Maintenance Engineer"
          src={ProductionManagerImg}
          buttoncont1="Explore"
          href1="/maintenance-engineer"
        />

        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="agribusiness-img"
          description="A Plant Operator/Worker is responsible for operating machinery, monitoring production processes, and maintaining equipment in a manufacturing plant."
          descriptionTitle="Plant Operator/ Worker"
          src={ProductionManagerImg}
          buttoncont1="Explore"
          href1="/plant-operator"
        />

        <HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="agri-foodmanufacturer-img"
          description="A Plant Executive oversees manufacturing operations, ensuring efficient production, quality control, and compliance with safety standards."
          descriptionTitle="Plant Executive"
          src={ProductionManagerImg}
          buttoncont1="Explore"
          href1="/plant-executive"
        />
      </div>

      {/* PPN Network Operators Section */}
      <div className="subSectionWrapper main-wrapper">
        <h2 className="container-title text-center">PPN NETWORK OPERATORS</h2>

        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards"
          className3="agribusiness-img"
          description="A Plant Owner/Processing Entrepreneur manages the food processing unit, ensuring efficient production and handling contract manufacturing orders."
          descriptionTitle="Plant Owner/ Processing Entrepreneur"
          src={ProductionManagerImg}
          buttoncont1="View PPN deployment for plant owner"
          href1="/plant-owner"
        />
      </div>
    </>
  );
}
